const ResendButton = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="btn btn-link p-0 m-0 align-baseline"
    >
      Resend code
    </button>
  );
};

export default ResendButton;
